export class Router {
  constructor() {
    this.routes = new Map();
    this.currentRoute = null;
    this.notFoundHandler = null;
  }

  register(pattern, handler) {
    const paramNames = [];
    const regexPattern = pattern.replace(/:([^/]+)/g, (_, name) => {
      paramNames.push(name);
      return '([^/]+)';
    });

    this.routes.set(pattern, {
      pattern,
      regex: new RegExp(`^${regexPattern}$`),
      paramNames,
      handler
    });
  }

  setNotFound(handler) {
    this.notFoundHandler = handler;
  }

  navigate(path) {
    window.location.hash = path;
  }

  resolve() {
    const hash = window.location.hash.slice(1) || '/';
    const [path, queryString] = hash.split('?');
    const query = new URLSearchParams(queryString || '');

    for (const route of this.routes.values()) {
      const match = path.match(route.regex);
      if (match) {
        const params = {};
        route.paramNames.forEach((name, index) => {
          params[name] = decodeURIComponent(match[index + 1]);
        });

        this.currentRoute = { path, params, query };
        return route.handler({ path, params, query });
      }
    }

    if (this.notFoundHandler) {
      this.currentRoute = { path, params: {}, query };
      return this.notFoundHandler({ path, params: {}, query });
    }

    return null;
  }

  getCurrentRoute() {
    return this.currentRoute;
  }

  start() {
    window.addEventListener('hashchange', () => this.resolve());
    return this.resolve();
  }
}
